import UnitItem from "src/components/UnitItem"
import "./UnitsCanvas.css"

// Three to a line at most (owner, 2026-09-10). A player can field five kinds of unit, so three
// across and two down holds every garrison there is — which is why the roster needs no scroller
// and no reel: everything a city has is on screen at once.
const MAX_COLUMNS = 3

/* The units on a cell, as chips.

   Two layouts, because the panel asks for the same chips in two shapes. `strip` is the original:
   one row, scrolling if it has to, which is what the "total units" line at the top of the roster
   wants — one army read left to right. `grid` is the roster row's: as many columns as there are
   kinds, up to three, wrapping to a second row past that.

   The column count is set here rather than in CSS because CSS cannot count children, and it is
   what makes a city with one kind of unit draw one big chip instead of one small chip and two
   empty thirds. */
const UnitsCanvas = ({ unitsInfo, layout = "strip" }) => {
  const kinds = unitsInfo.filter((u) => u.number > 0)
  const chips = kinds.map((u) => <UnitItem key={u.type} type={u.type} count={u.number} />)

  if (layout !== "grid") {
    return <div className="unit-strip with-scroll-bar horizontal">{chips}</div>
  }

  return (
    <div className="unit-grid" style={{ "--unit-cols": Math.min(MAX_COLUMNS, Math.max(1, kinds.length)) }}>
      {chips}
    </div>
  )
}

export default UnitsCanvas
